module.exports = __webpack_public_path__ + "img/device_1004_2.938a33ba.svg";